import React, { useState, useEffect } from "react";
import FraudAlertReminderDialog from "../Dialogs/FraudAlertReminderDialog";
import { notification } from "antd";
import { DialogComponent } from "./../common/DialogComponent";
import * as services from "../../store/service";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../util/dateFormatting";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { sendRequest } from "../../util/httpClient";

const FraudAlertReminderCard = () => {
    const { t: tLang } = useTranslation();
    const [showDialog, setShowDialog] = useState(false);
    const [state, setState] = useState({ reminderDate: "", showSetReminderBtn: false });

    const openNotification = (type: any, desc: string, duration: number = 5): any => {
        (notification as any)[type]({
            message: tLang("credit.creditScore.fraudAlertReminderWidget.toasterMessage.success.title"),
            description: desc,
            placement: "bottomLeft",
            className: "ant-notification-bottomLeft",
            duration: duration,
        });
    };

    const handleStateChange = (reminderDate: string, showSetReminderBtn: boolean): any => {
        setState({
            reminderDate: reminderDate,
            showSetReminderBtn: showSetReminderBtn,
        });
    };

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseDialog = (): any => {
        setShowDialog(false);
    };

    const callAPI = (url: string, data: any): Promise<any> => {
        return sendRequest("POST", url, data, {}, true);
    };

    const getFraudAlertReminder = (): void => {
        services.getFraudAlertReminder().then((response: { statusCode: string; data: { reminderDate: string } }) => {
            if (response.statusCode && response.statusCode === "200") {
                if (response.data && response.data.reminderDate) {
                    handleStateChange(response.data.reminderDate, false);
                } else {
                    handleStateChange("", false);
                }
            } else {
                handleStateChange("", false);
            }
        });
    };

    const formatDate = (date: string): string => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        const dateObj = new Date(date.split(" ")[0].replace(/-/g, "/"));
        return dateObj.toLocaleDateString([], options);
    };

    useEffect(getFraudAlertReminder, []);

    return (
        <React.Fragment>
            <div className="box box-border-top">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon position-right" aria-hidden="true">
                            <em className="las la-calendar-day"></em>
                        </div>
                        <div className="box-title-text">
                            <h3 className="box-title">{tLang("credit.creditScore.fraudAlertReminderWidget.title")}</h3>
                        </div>
                    </div>
                </div>
                <div className="box-content">
                    {!state.reminderDate && <p>{tLang("credit.creditScore.fraudAlertReminderWidget.messageNoAlert")}</p>}
                    {state.reminderDate && (
                        <p>
                            <strong>
                                {tLang("credit.creditScore.fraudAlertReminderWidget.messagewithAlert")}{" "}
                                {getFormattedDate(i18nService.get("Country"), formatDate(state.reminderDate))}.
                            </strong>
                        </p>
                    )}
                    <p>
                        <button
                            type="button"
                            className="btn-default btn-secondary-outline"
                            data-a11y-dialog-show="dialog-set-fraud-alert-reminder"
                            onClick={() => {
                                handleClick();
                                window.addToDataLayer({ event: "Set a Fraud Alert Reminder" });
                            }}
                        >
                            <span className="btn-text">{tLang("credit.creditScore.fraudAlertReminderWidget.setReminderButtonText")}</span>
                        </button>
                    </p>
                </div>
            </div>

            {showDialog && (
                <DialogComponent dialogId="dialog-set-fraud-alert-reminder" title="Fraud Alert Reminder" closeDialog={handleCloseDialog}>
                    <FraudAlertReminderDialog
                        {...state}
                        callAPI={callAPI}
                        formatDate={formatDate}
                        openNotification={openNotification}
                        handleStateChange={handleStateChange}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default FraudAlertReminderCard;
